import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import VideoBanner from '@/pages/home/components/VideoBanner';
import Hero from '@/pages/home/components/Hero';
import Trust from '@/pages/home/components/Trust';
import Categories from '@/pages/home/components/Categories';
import HowItWorks from '@/pages/home/components/HowItWorks';
import Practitioners from '@/pages/home/components/Practitioners';
import FeaturedPractitioners from '@/pages/home/components/FeaturedPractitioners';
import Faq from '@/pages/home/components/Faq';
import Cta from '@/pages/home/components/Cta';
import Contact from '@/pages/home/components/Contact';

export default function Home() {
  return (
    <div className="min-w-[320px] bg-background-50">
      <Navbar />
      <main>
        <VideoBanner />
        <Hero />
        <Trust />
        <Categories />
        <HowItWorks />
        <Practitioners />
        <FeaturedPractitioners />
        <Faq />
        <Cta />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}